import { SchedulerService } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/scheduler.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSchedulerV3Service = bindHTTP(SchedulerService);
export const serviceName = 'scheduler-v3' as const;
